import React from 'react'
import { AppSvg, FormattedHTMLMessage, IconWithBackground, NavMenuItem, newIcons } from '@web/walter-ui-kit'
import { useTheme } from '@web/walter-lib/theme'

import s from './style.module.css'
import { lang } from '~components/App/Layout/NavigationMenu/lang'
import { useCommonCMSConfig } from '~api'

interface Props {
    isIcon?: boolean
}

function ThemeButton({ isIcon }: Props) {
    const { themes } = useCommonCMSConfig().data ?? {}
    const { isNight, setTheme } = useTheme()

    const showThemeButton = themes && Object.values(themes).filter(Boolean).length > 1

    if (!showThemeButton) {
        return null
    }

    const onThemeClick = () => {
        if (!themes?.day || !themes.night) {
            return
        }

        setTheme?.(isNight ? themes.day : themes.night)
    }

    if (isIcon) {
        return (
            <div onClick={onThemeClick} className={s.iconButton} data-pointer="theme_button">
                <IconWithBackground
                    size={40}
                    type="default"
                    icon={
                        <AppSvg path="new-icons" size={24} svgName={isNight ? newIcons.ic24Sun : newIcons.ic24Moon} />
                    }
                />
            </div>
        )
    }

    return (
        <NavMenuItem
            dataPointer="theme_button"
            icon={<AppSvg svgName={isNight ? newIcons.ic24Sun : newIcons.ic24Moon} path="new-icons" size={24} />}
            type="button"
            onClick={onThemeClick}
        >
            <FormattedHTMLMessage {...(isNight ? lang.switchToDay : lang.switchToNight)} />
        </NavMenuItem>
    )
}

export default ThemeButton
